import { defineMessages } from 'react-intl';

export const messages: {
	groupLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	allFilterLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noMatchingResultsTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	connectedAppsHeader: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	connectAppsHeader: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	connectAppsDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	groupLabel: {
		id: 'search-page.app-filter-sidebar.group',
		defaultMessage: 'Filter search by app',
		description: 'aria label for the group of product filters',
	},
	allFilterLabel: {
		id: 'search-page.app-filter-sidebar.all',
		defaultMessage: 'All',
		description:
			'Label for button that filters search to all products (e.g. All, Confluence, Jira)',
	},
	noMatchingResultsTooltip: {
		id: 'search-page.app-filter-sidebar.no-matching-results-tooltip',
		defaultMessage: 'No matching results in {product}',
		description: 'Tooltip text shown on a product when there are no matching results',
	},
	connectedAppsHeader: {
		id: 'search-page.app-filter-sidebar.connected-apps-header',
		defaultMessage: 'Filter results',
		description: 'Header for the section of connected products/apps',
	},
	connectAppsHeader: {
		id: 'search-page.app-filter-sidebar.connect-apps-header',
		defaultMessage: 'Connect apps',
		description: 'Header for the section of unconnected products/apps that need to be connected',
	},
	connectAppsDescription: {
		id: 'search-page.app-filter-sidebar.connect-apps-description',
		defaultMessage: 'Get better answers and more results across Search and Chat.',
		description: 'Description text shown below the "Connect apps" header',
	},
});
